import { Box } from "@mui/material";
import IrrigationTypeForm from "../components/forms/irrigationTypeForm.component";
import { useDispatch, useSelector } from "react-redux";
import CustomAlert from "../components/alert/alert.component";
import { getErrorMessage } from "../utils/errorUtils";
import { createIrrigationTypeStart } from "../store/features/irrigationType/irrigationTypeSlice";
import { useIsMobile } from "../hook/useIsMobile";

const AddIrrigationPage = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector(
    (state) => state.irrigationType
  );

  const defaultValues = {
    name: "",
  };

  const onSubmit = (data) => {
    dispatch(createIrrigationTypeStart({ data, accessToken: accessToken }));
  };

  return (
    <Box width="100%">
      {error && (
        <CustomAlert
          severity="error"
          message={getErrorMessage(error, {
            fallback: "Errore durante la creazione dell'irrigazione.",
            messages: {
              error_generic_400:
                "L'irrigazione inserita è già presente.",
            },
          })}
        />
      )}
      <IrrigationTypeForm
        mode="create"
        isMobile={isMobile}
        onSubmit={onSubmit}
        isLoading={isLoading}
        error={error}
        success={success}
        defaultValues={defaultValues}
      />
    </Box>
  );
};

export default AddIrrigationPage;
